import React from 'react';
import { FormattedMessage } from 'react-intl';
import useLanguageCode from 'hooks/useLanguageCode';
import * as styles from './styles/styles.module.scss';

const HelpButton = (): JSX.Element => {
  const languageCode = useLanguageCode();
  const supportLink = `https://support.alltrails.com/hc/${languageCode}/articles/360019245911-How-do-I-create-a-map-`;
  return (
    <a className={styles.button} target="_blank" rel="noreferrer" href={supportLink}>
      <FormattedMessage defaultMessage="Need help?" />
    </a>
  );
};

export default HelpButton;
